import type { Voucher, VoucherStatus } from './types';
import { approvalSteps } from './logic';
import type { StateTone } from './view';

// Mint-Cost › tab Đề nghị thanh toán: nhóm lọc, nhãn trạng thái (DNStatus TblOpsDN), chip bước duyệt — theo code board (RS · RG · stepChips).

export const REQ_GROUPS = ['Tất cả', 'Hãng tàu', 'Cảng · HQ', 'Vận tải', 'Tạm ứng', 'Hoàn phí', 'Đối chiếu đối tác', 'Khác'] as const;
export type ReqGroup = (typeof REQ_GROUPS)[number];

export const REQ_STATUS: Readonly<Record<VoucherStatus, { label: string; tone: StateTone | 'blue' }>> = {
  c1: { label: 'Created · chờ cấp 1', tone: 'warn' },
  kt: { label: 'Confirmed · chờ kế toán', tone: 'blue' },
  gd: { label: 'Confirmed · chờ ACC-CA', tone: 'violet' },
  done: { label: 'Approved', tone: 'ok' },
  rq: { label: 'RQ Payment · trong đợt chi', tone: 'blue' },
  paid: { label: 'Payment Done', tone: 'ok' },
  back: { label: 'Need Revise', tone: 'err' },
};

export const STEP_LABEL = { c1: 'Cấp 1', kt: 'Kế toán', gd: 'Duyệt chi ACC-CA' } as const;
export type Step = keyof typeof STEP_LABEL;

export interface StepChip { key: Step; label: string; tone: 'done' | 'now' | 'todo'; tip: string }

export function stepChips(v: Pick<Voucher, 'total' | 'status' | 'maker'>): StepChip[] {
  const order = approvalSteps(v);
  const idx = v.status === 'done' || v.status === 'rq' || v.status === 'paid' ? 99 : order.indexOf(v.status as Step);
  return order.map((key, j) => {
    const who: Record<Step, string> = {
      c1: '[OPS-MGR · Trưởng vận hành] PHONGNT',
      kt: v.maker === 'LIENNTK' ? '[ACC-CA · Kế toán trưởng] Ghế trống · leo lên BOD-DIR PHILIP · người lập giữ ghế ACC-CP nên đẩy lên ghế trên' : '[ACC-CP · Kế toán chi phí] LIENNTK',
      gd: '[ACC-CA · Kế toán trưởng] Ghế trống · leo lên BOD-DIR PHILIP · vượt ngưỡng',
    };
    const tone = j < idx ? 'done' : j === idx ? 'now' : 'todo';
    return { key, label: (tone === 'done' ? '✓ ' : '') + STEP_LABEL[key], tone, tip: who[key] };
  });
}

export function requestNote(v: Pick<Voucher, 'status' | 'duplicate' | 'slow' | 'maker'>): string | null {
  if (v.status === 'back') return 'Ảnh biên nhận mờ · ANHLT nhập lại';
  if (v.duplicate) return 'Job đã có đề nghị phí hãng tàu cùng mã phí';
  if (v.slow) return 'Chờ cấp 1 quá 2 ngày làm việc';
  if (v.maker === 'LIENNTK') return 'Người lập giữ ghế ACC-CP → bước kế toán đẩy lên ghế trên';
  return null;
}

export const groupCount = (rows: readonly Pick<Voucher, 'group'>[], g: ReqGroup): number => (g === 'Tất cả' ? rows.length : rows.filter((r) => r.group === g).length);
